import { customAxios } from '../../axios/CustomAxios';
import {myIpAddress} from "../../config";

/**
 * 복지포인트 결재 승인 
 * @param {*} body 
 * @returns 
 */

const wpApproval =(body)=>{
    return customAxios.post(myIpAddress+'/wp/approval', body ); 
}
export default wpApproval;
